import { FormOption } from 'types';

export const actions = {
  storeShipping: 'DRIVER_COLLECTED',
  shippingFail: 'DELIVERY_FAIL_BY_DRIVER',
  pickUpStoreShipping: 'CUSTOMER_PICKED_UP_STORE_SHIPPING',
  pickUp: 'CUSTOMER_PICKED_UP',
};

export const deliveryFailReasons: FormOption[] = [
  { label: 'Destinatário ausente', value: 'ABSENT_RECIPIENT' },
  { label: 'Endereço inválido ou incompleto', value: 'INCORRECT_ADDRESS' },
];

export const deliveryModes: FormOption[] = [
  { label: 'Eu-Entrego', value: '739' },
  { label: 'Flash-Courier-SFS', value: '12165' },
  { label: 'Flash STZ LS', value: '17291' },
  { label: 'Uber', value: '15412' },
  { label: 'Mottu', value: '17761' },
  { label: 'Tex SFS', value: '18891' },
  { label: 'Tex SFS São Paulo', value: '18905' },
  { label: 'TEX SFS RJ', value: '20019' },
  { label: 'Jadlog SFS', value: '18890' },
  { label: 'Jadlog Meia Sola', value: '19293' },
  { label: 'Jadlog-SFS-RJ', value: '19958' },
  { label: 'R3 SFS', value: '20319' },
  { label: 'Liftit Brasil', value: '9751' },
  { label: 'Stone Entregas', value: '21567' },
  { label: 'Uber', value: '15412' },
];
